import React, { useState, useEffect } from "react";
import { API_BASE_URL, BASE_URL } from "../apiConfig";

function Slider({ banners = [] }) {
  const baseUrl = BASE_URL;

  return (
    <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
      <ol className="carousel-indicators">
        {banners.map((_, index) => (
          <li
            key={index}
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to={index}
            className={index === 0 ? "active" : ""}
          ></li>
        ))}
      </ol>

      <div className="carousel-inner">
        {banners.length > 0 ? (
          banners.map((banner, index) => {
            const imageUrl = `${baseUrl}${banner}`;

            return (
              <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`}>
                <img 
                  className="d-block w-100" 
                  src={imageUrl} 
                  alt={`Slide ${index + 1}`} 
                  loading="lazy" 
                  style={{ minHeight: '300px', backgroundColor: '#f0f0f0' }}
                />
              </div>
            );
          })
        ) : (
          <div className="carousel-item active">
            <div className="d-block w-100 d-flex align-items-center justify-content-center" style={{ height: '300px', backgroundColor: '#f8f9fa' }}>
               <p>Loading banners...</p>
            </div>
          </div>
        )}
      </div>

      <button className="carousel-control-prev" href="#carouselExampleIndicators" data-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="sr-only">Previous</span>
      </button>

      <button className="carousel-control-next" href="#carouselExampleIndicators" data-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="sr-only">Next</span>
      </button>
    </div>
  );
}

export default Slider;



// import React from 'react';
// import Slider1 from './../assets/images/slider/slide1.jpg';
// import Slider2 from './../assets/images/slider/slide2.jpg';
// import Slider3 from './../assets/images/slider/slide3.jpg';

// function Slider() {
//   return (
//     <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
//       <ol className="carousel-indicators">
//         <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active"></li>
//         <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
//         <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
//       </ol>
//       <div className="carousel-inner">
//         <div className="carousel-item active">
//           <img className="d-block w-100" src={Slider1} alt="First slide" />
//           <div className="card-body text-center">
//             <span className="h4 d-block">Mark Henry</span>
//             <span>Photographer</span>
//           </div>
//         </div>
//         <div className="carousel-item">
//           <img className="d-block w-100" src={Slider2} alt="Second slide" />
//           <div className="card-body text-center">
//             <span className="h4 d-block">Mark Henry</span>
//             <span>Photographer</span>
//           </div>
//         </div>
//         <div className="carousel-item">
//           <img className="d-block w-100" src={Slider3} alt="Third slide" />
//           <div className="card-body text-center">
//             <span className="h4 d-block">Mark Henry</span>
//             <span>Photographer</span>
//           </div>
//         </div>
//       </div>
//       {/* <button className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
//         <span className="carousel-control-prev-icon" aria-hidden="true"></span>
//         <span className="sr-only">Previous</span>
//       </button>
//       <button className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
//         <span className="carousel-control-next-icon" aria-hidden="true"></span>
//         <span className="sr-only">Next</span>
//       </button> */}

//       <button className="carousel-control-prev" href="#carouselExampleIndicators" data-slide="prev">
//           <span className="carousel-control-prev-icon" aria-hidden="true"></span>
//           <span className="sr-only">Previous</span>
//         </button>

//         <button className="carousel-control-next" href="#carouselExampleIndicators" data-slide="next">
//           <span className="carousel-control-next-icon" aria-hidden="true"></span>
//           <span className="sr-only">Next</span>
//         </button>
//   </div>
//   );
// }
// export default Slider;
